import {
  REQUEST_LOGIN, SUCCESS_LOGIN, FAILED_LOGIN, CODE_REQUIRED,
  LOGOUT, SET_REDIRECT, UPDATE_TOKEN
} from '../actions/auth';

export default function auth(state = {
  loading: false,
  loaded: false,
  user: null,
  redirect: null,
}, action) {
  switch (action.type) {
    case LOGOUT:
      return {
        ...state,
        user: null,
        loaded: false,
        redirect: action.payload.redirect ? state.redirect : null,
      }
    case REQUEST_LOGIN:
      return {
        ...state,
        loading: true
      };
    case SUCCESS_LOGIN:
      return {
        ...state,
        loading: false,
        loaded: true,
        user: action.payload.user,
        lastUpdated: action.payload.receivedAt,
      };
    case FAILED_LOGIN:
    case CODE_REQUIRED:
      return {
        ...state,
        loading: false
      };
    case UPDATE_TOKEN:
      return {
        ...state,
        user: state.user ? { ...state.user, token: action.payload.token } : state.user,
      }
    case SET_REDIRECT:
      return {
        ...state,
        redirect: action.payload.redirect,
      }
    default:
      return state;
  }
}
